<template>

	<div class="module_course">

		<course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

		<div class="row page-content">

			

			<div class="col-11 dasboard-left-section">
		      	<b-col cols="12" class="course-description">
    		        <b-row class="dashboard-row">
    		          <b-col cols="4">
    		              <div class="card">
    				        <div class="card-body">
    						  <p class="card-text">Distribution</p>
    						</div>
    		              </div>
    		          </b-col>
    		          <b-col cols="4">
    						  <div class="card">
    							  <div class="card-body">
                                      <p class="card-text">Scores</p>
    							  </div>
    						  </div>
    		          </b-col>
    		          <b-col cols="4">
    						<div class="card">
    							<div class="card-body">
    								<p class="card-text">Time Taken</p>
    							</div>
    					   </div>
    		          </b-col>
    		        </b-row>
    		        
    		        Competencies
            
                    <b-row class="activity-row dashboard-row">
                    </b-row>
    		        
		        </b-col>
		    </div>
		</div>

	  </div>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'

export default {
  name: 'classPerformance',
  props: ['courseId'],
  components: {
    CourseNav,
    CourseHeader
  },
  data: () => {
    return {}
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.courseId)
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course
    })
  }
}
</script>

<style scoped>
.course-nav {
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item {
  background:#e1e1e1;
  border: none;
}

.course-thumbnail {
  background:#f8f9fa;
  min-height: 500px;
}

.course-information {
  margin-top:20px;
}

.course-description {
  padding-top:20px;
}

.activity-row {
  padding-top:20px;
}

.card {
  border: none!important;
}

.card-header {
  background:#f8f9fa!important;
}

.card-body {
  background:#f8f9fa!important;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/ClassPerformance.vue